import {
    buildSelectPromoModelInput,
    isPromozavrRouteAllowed,
    parsePromozavrQueryParams,
} from '../../../../../common/helpers';
import type { InitPromozavrPayload, PromozavrRendererSource, SelectPromoModelInput } from './types';

type ResolvedPromozavrInit = {
    request: SelectPromoModelInput;
    requestKey: string;
    rendererSource: PromozavrRendererSource;
};

type ResolvePromozavrInitArgs = InitPromozavrPayload & {
    lang?: string;
    tld?: string;
    testIds?: string[];
    isYandexNet: boolean;
    allowDebugParams?: boolean;
    shouldUsePaas: boolean;
    shouldUsePdokPromoRenderer: boolean;
};

export function resolvePromozavrInit(
    {
        pathname,
        search,
        requestKey,
        lang,
        tld,
        testIds = [],
        isYandexNet,
        allowDebugParams = false,
        shouldUsePaas,
        shouldUsePdokPromoRenderer,
    }: ResolvePromozavrInitArgs,
    resolveRendererSource: (shouldUsePdokPromoRenderer: boolean) => PromozavrRendererSource
): ResolvedPromozavrInit | undefined {
    if (!shouldUsePaas || !isPromozavrRouteAllowed(pathname)) {
        return;
    }

    const promozavrQueryParams = parsePromozavrQueryParams(search);
    const promozavrDebugQueryParams = isYandexNet || allowDebugParams ? promozavrQueryParams : {};
    const request = buildSelectPromoModelInput({
        lang,
        tld,
        testIds,
        ...promozavrDebugQueryParams,
        app: promozavrQueryParams.app,
    });

    return {
        request,
        requestKey,
        rendererSource: resolveRendererSource(shouldUsePdokPromoRenderer),
    };
}
